
import { commonfunc } from '~/mixin/common'
import { pushBannerGtmData } from '~/utils/gtm'
import commonImage from '~/components/common/CommonImage.vue'

export default {
  components: {
    commonImage
  },
  mixins: [commonfunc],
  props: {
    options: {
      type: Object,
      default: () => {
        return {
          auto: false,
          loop: false,
          navigation: false,
          pagination: ''
        }
      }
    },
    banrList: {
      type: [Array, Number],
      default: () => {
        return []
      }
    },
    swiperType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      swiperOpt: {
        slidesPerView: 1,
        loop: true,
        lazy: true,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        // 23.10.13 페이징 속성 변경
        pagination: {
          el: '.swiper-wrap .swiper-pagination',
          clickable: true,
          type: 'bullets', // 버튼 디자인 bullets" / "fraction"
          renderBullet (index, className) {
            return '<button type="button" aria-label="' + (index + 1) + '번 슬라이드로 이동하기" class="' + className + '"><span class="hiddenText">' + (index + 1) + '</span></button>'
          },
          renderFraction (currentClass, totalClass) {
            return '<span class="' + currentClass + '"></span>' + '<span class="' + totalClass + '"></span>'
          }
        },
        freeMode: false,
        slidesPerColumn: 1,
        grid: {
          rows: 1
        }
      },
      autoStatus: true,
      cdnUrl: process.env.CDN_BASE_URL ?? process.env.CDN_BASE_URL,
    }
  },
  computed: {
    swiper () {
      return this.$refs.ctenMainSwiper.swiper
    }
  },
  created () {
    // 자동롤링
    if (!this.options.auto) {
      this.swiperOpt.autoplay = this.options.auto
      this.autoStatus = false
    } else if (typeof this.options.auto === 'number') {
      this.swiperOpt.autoplay.delay = this.options.auto
      this.autoStatus = false
    }

    // 무한루프
    if (!this.options.loop) {
      this.swiperOpt.loop = this.options.loop
    }

    // 인디케이터
    if (this.options.pagination === 'fraction') {
      console.log('## fraction')
      this.swiperOpt.pagination.type = this.options.pagination
    } else if (this.options.pagination === 'tab') {
      const tabInd = this.tabIndicator
      this.swiperOpt.pagination = {
        el: '.swiper-pagination',
        clickable: true,
        type: 'bullets', // 버튼 디자인 bullets" / "fraction"
        renderBullet (index, className) {
          return '<button type="button" aria-label="' + (index + 1) + '번 슬라이드로 이동하기" class="' + className + '"><span class="">' + tabInd[index] + '</span></button>'
        }
      }
    }
    // console.log('## swiperOptswiperOptswiperOpt : ', this.swiperOpt)
  },
  mounted () {
    if (this.banrList.length === 1) {
      this.swiperDestroy()
    }

    this.$nextTick(() => {
      this.videoLazyCtrl()
    })
  },
  methods: {
    stopSwiper () {
      console.log('stop', this.$refs.ctenMainSwiper)
      this.$refs.ctenMainSwiper.swiper.autoplay.stop()
      this.autoStatus = false
    },
    playSwiper () {
      console.log('play')
      this.$refs.ctenMainSwiper.swiper.autoplay.start()
      this.autoStatus = true
    },
    swiperDestroy () {
      this.$refs.ctenMainSwiper.swiper.destroy()
    },
    videoOptions (src, thmn) {
      return {
        controls: false, // 컨트롤 바 노출 여부
        autoplay: true, // 자동재생
        muted: true, // 음소거
        loop: true,
        preload: 'metadata',
        poster: thmn,
        sources: [
          {
            // src: 'http://devf.daisomall.co.kr:3011' + item.pcVideoAtchFileUrl,
            src,
            type: 'video/mp4'
          }
        ]
        // , playbackRates: [1] // 배속
      }
    },
    videoLazyCtrl () { // video 정지/재생 기능
      // video 선택자
      const lazyVideo = document.querySelectorAll('.video-wrap auto')
      // const lazyVideo = this.$el

      // 옵션 (video 선택자가 viewprot에 교차되는 옵션 설정)
      const options = {
        root: null,
        rootMargin: '-250px -40px -250px -40px',
        threshold: [0.4]
      }
      // 콜백함수
      const onSensor = (entries) => {
        entries.forEach((entry) => {
          // console.log('## swiperVideo entry 여부 : ' + entry.isIntersecting)
          if (lazyVideo.closest('.video-wrap') === null) { return false } // video 선택자 못 가져올 경우 return
          const valId = lazyVideo.closest('.video-wrap').getAttributeNode('id').value.slice(6)
          if (!entry.isIntersecting) {
            this.$refs[`video${valId}`][0].player.pause()
          } else if (entry.isIntersecting) {
            this.$refs[`video${valId}`][0].player.play()
          }
        })
      }
      // 인스턴스
      const videoIob = new IntersectionObserver(onSensor, options)
      // 실행
      // videoIob.observe(lazyVideo)
      lazyVideo.forEach((video) => {
        videoIob.observe(video)
      })
    },
    clickBanner (item) {
      const gtmItem = {
        fileNm: item.pcomIconOrglFileNm
      }
      pushBannerGtmData(gtmItem, false)
      console.log('banrLinkMvmnTyCd ===', item.banrLinkMvmnTyCd)
      if (item.banrLinkMvmnTyCd === '02') {
        window.open(item.pcomLinkUrl)
      } else {
        this.$router.push(item.pcomLinkUrl)
      }
    }
  }
}
